import { render } from "./Attributes.vue?vue&type=template&id=14f56ca0&scoped=true"
import script from "./Attributes.vue?vue&type=script&lang=js"
export * from "./Attributes.vue?vue&type=script&lang=js"

import "./Attributes.vue?vue&type=style&index=0&id=14f56ca0&scoped=true&lang=css"

import exportComponent from "../../../../../app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-14f56ca0"]])

export default __exports__